// src/components/AlertModal.js
import React from "react";
import { useTranslation } from "react-i18next";
import "./AlertModal.css";

export default function AlertModal({ 
  open, 
  title, 
  message, 
  onClose, 
  buttonText 
}) {
  const { t } = useTranslation();

  if (!open) return null;

  return (
    <div className="confirm-overlay" onClick={onClose}>
      <div className="confirm-modal" onClick={e => e.stopPropagation()}>
        <div className="confirm-title">
          {title || t("commonLabel.notification", "Notification")}
        </div>
        <div className="confirm-text">{message}</div>
        <div className="confirm-actions">
          <button className="btn-mini primary" onClick={onClose}>
            {buttonText || t("commonLabel.ok", "OK")}
          </button>
        </div>
      </div>
    </div>
  );
}